module.exports = __webpack_public_path__ + "img/Token_p3.7401508a.png";